import { render, staticRenderFns } from "./ShiftStartPage.vue?vue&type=template&id=5f05e18c"
import script from "./ShiftStartPage.vue?vue&type=script&lang=js"
export * from "./ShiftStartPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports